import {ReadinessIcon,ReadinessNavLink} from './BuildingReadiness';
import {WorkspaceMoreLinks} from './WorkspaceMoreLinks';
import {useLocation} from 'react-router';
import {type IconName} from './Icon';
import type {WorkspaceNavigation} from './area-navigation';

/** Reorder only destinations already permitted by the canonical workspace navigation. */
export function RepairWorkspaceRail({navigation}:{navigation:NonNullable<WorkspaceNavigation['tertiary']>}){
 const location=useLocation();
 if(navigation.area!=='repairs')return null;
 const key=(href:string)=>{const url=new URL(href,'https://staff.invalid');url.searchParams.delete('building');url.searchParams.sort();return url.pathname+'?'+url.searchParams};
 const definitions:Array<{href:string;label:string;icon:IconName}>=[
  {href:'/engines/repairs',label:'Overview',icon:'layout-dashboard'},
  {href:'/work/all',label:'Repairs & work',icon:'wrench'},
  {href:'/work/all?status=Procurement',label:'Procurement',icon:'scale'},
  {href:'/work/suppliers',label:'Contractors',icon:'hard-hat'},
  {href:'/work/awaiting-evidence',label:'Evidence to review',icon:'file-text'},
  {href:'/work/repair-performance',label:'Repair performance',icon:'chart-column'},
 ];
 const allowed=navigation.sections.flatMap(section=>section.items);
 const items=definitions.flatMap(definition=>{const permitted=allowed.find(item=>key(item.href)===key(definition.href));return permitted?[{...permitted,...definition,href:permitted.href}]:[]});
 const used=new Set(items.map(item=>key(item.href))),extras=allowed.filter(item=>!used.has(key(item.href)));
 return <nav className="workspace-family-navigation repairs-family-navigation" aria-label="Repairs navigation"><ul>{items.map(item=><li key={item.id}>
  <ReadinessNavLink to={item.href} aria-current={navigation.active===item.id?'page':undefined}><ReadinessIcon name={item.icon} href={item.href}/><span>{item.label}</span></ReadinessNavLink>
 </li>)}</ul><WorkspaceMoreLinks items={extras} isCurrent={item=>navigation.active===item.id||key(item.href)===key(location.pathname+location.search)}/></nav>;
}
